import { Button } from "PFComponents/button";
import { Typography } from "PFComponents/typography";
import { getProfileName } from "PFCore/helpers/profile";
import React from "react";

import { useMatchProfileInfo } from "../../hooks/use_match_profile_info";
import { useShowMatchProfileSidePanel } from "../../hooks/use_show_match_profile_side_panel";
import { useMatchCardContext } from "../../match_card_context";
import { MatchActivitySkills } from "../match_activity_skills";
import css from "./match_card_header.module.scss";

export const MatchProfileInfo = () => {
  const { profile, isCompressed } = useMatchCardContext();
  const { headerInfo: headerProfileInfo } = useMatchProfileInfo();
  const openProfileSidePanel = useShowMatchProfileSidePanel();

  const formattedHeaderProfileInfo = headerProfileInfo.map(({ value }) => value).join(", ");

  return (
    <div className={css.matchProfileInfo}>
      <Button kind="blank" onClick={openProfileSidePanel} theme={{ root: css.matchProfileName }}>
        <Typography variant="h4" noMargin>
          {getProfileName(profile)}
        </Typography>
      </Button>
      {formattedHeaderProfileInfo && (
        <Typography variant="labelRegular" noMargin>
          {formattedHeaderProfileInfo}
        </Typography>
      )}
      {!isCompressed && <MatchActivitySkills className={css.skills} />}
    </div>
  );
};
